export default "../css/31cfb244ee156678ab978ec14b48ef17.ttf";